//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Features/Features.ShipDesign.StiffenerLimitBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[1,"EndBoundary",0,"Features.ShipDesign.StiffenerLimitBuilder",0],[1,"SelectedStiffeners",0,"SelectTaggedObjectList",0],[1,"StartBoundary",0,"Features.ShipDesign.StiffenerLimitBuilder",0]],[[["selectedStiffener"],"GetStiffenerBuilder",{R_:{stiffenerBuilder:"Features.ShipDesign.StiffenerBuilder"}},1,0],[["srcStiffenerLimit","dstStiffenerLimit","stiffenerBuilder","dstPart"],"FillStiffenerLimitInformation",{},4,0],[[],"RemoveStartLimitGeometry",{},0,0],[[],"RemoveEndLimitGeometry",{},0,0]],[]];
SPLM.Features.ShipDesign.DetailEditBoundaryBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.DetailEditBoundaryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;